module.exports = __webpack_public_path__ + "img/26dcd0f.jpg";